import ContactsPage from '../pages/dashboard/components/pages/ContactsPage';

export default function ContactsRoute() {
  return <ContactsPage />;
}
